import { get } from 'lodash-es';

import { emptyArray } from 'ui-components/default-props/empty';

import type {
  OrdersDrawerInventoryInfo,
  OrdersDrawerLastAppliedRecommendation,
  OrdersDrawerSectionState,
  OrdersDrawerState,
} from './orders.drawer.types';
import type { RootState } from 'store/root-state';

type OrdersDrawerReturnsProps = {
  salesOrderId: string;
};

export const selectLoadingState = (state: OrdersDrawerState): boolean => get(state, 'isLoading', false);
export const selectionSectionStates = (state: OrdersDrawerState): Record<string, OrdersDrawerSectionState> | false =>
  get(state, 'sectionStates', false);
// A props-only string builder that happens to live behind the barrel: it never reads state, but the
// parameter is part of the call signature every consumer already passes through.
export const selectReturnsFulfillmentPlanId = (state: OrdersDrawerState, props: OrdersDrawerReturnsProps): string =>
  `return-${get(props, 'salesOrderId')}`;
export const selectIsLoadingRates = (state: OrdersDrawerState): boolean => get(state, 'isLoadingRates');
export const selectSingleOrderDrawerModulesList = (state: OrdersDrawerState): string[] =>
  get(state, 'singleOrderDrawerModulesList', emptyArray as string[]);
export const selectMultiOrderDrawerModulesList = (state: OrdersDrawerState): string[] =>
  get(state, 'multiOrderDrawerModulesList', emptyArray as string[]);
export const selectIsValidatingAddress = (state: OrdersDrawerState): boolean | undefined => get(state, 'isValidatingAddress');

export const selectSingleOrderInventoryInfo = (state: OrdersDrawerState): OrdersDrawerInventoryInfo | undefined =>
  get(state, 'inventoryInfo');

export const selectLastAppliedRecommendation = (state: OrdersDrawerState): OrdersDrawerLastAppliedRecommendation | undefined =>
  state?.lastAppliedRecommendation;

export const selectOrdersDrawerLoadingState = (state: RootState): boolean => selectLoadingState(get(state, 'orders.drawer'));
export const selectOrdersDrawerionSectionStates = (state: RootState): Record<string, OrdersDrawerSectionState> | false =>
  selectionSectionStates(get(state, 'orders.drawer'));
export const selectOrdersDrawerReturnsFulfillmentPlanId = (state: RootState, props: OrdersDrawerReturnsProps): string =>
  selectReturnsFulfillmentPlanId(get(state, 'orders.drawer'), props);
export const selectOrdersDrawerIsLoadingRates = (state: RootState): boolean => selectIsLoadingRates(get(state, 'orders.drawer'));
export const selectOrdersDrawerSingleOrderDrawerModulesList = (state: RootState): string[] =>
  selectSingleOrderDrawerModulesList(get(state, 'orders.drawer'));
export const selectOrdersDrawerMultiOrderDrawerModulesList = (state: RootState): string[] =>
  selectMultiOrderDrawerModulesList(get(state, 'orders.drawer'));
export const selectOrdersDrawerIsValidatingAddress = (state: RootState): boolean | undefined =>
  selectIsValidatingAddress(get(state, 'orders.drawer'));
export const selectOrdersDrawerSingleOrderInventoryInfo = (state: RootState): OrdersDrawerInventoryInfo | undefined =>
  selectSingleOrderInventoryInfo(get(state, 'orders.drawer'));
export const selectOrdersDrawerLastAppliedRecommendation = (state: RootState): OrdersDrawerLastAppliedRecommendation | undefined =>
  selectLastAppliedRecommendation(get(state, 'orders.drawer'));
